<template>
  <div class="feeDetail_page">
    <Poptip trigger="hover" placement="bottom" @on-popper-show="onPopperShow" width="280" :transfer="true" popper-class="mingxiPop">
      <span style="text-decoration: underline; color: #1881DC; font-size: 12px;">明细</span>
      <div slot="content">
        <table>
          <thead>
          <tr>
            <th>服务大类</th>
            <th>服务子类</th>
            <th>当前交易服务费</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in this.tableData" :key="item.cust_no">
            <td>{{item.service_name}}</td>
            <td>{{item.subd_name}}</td>
            <td>{{item.rate}}%</td>
          </tr>
          </tbody>
        </table>
      </div>
    </Poptip>
  </div>
</template>
<script>
import { getAccountFreeDetail } from '@/api/userManager'
export default {
  name: 'feeDetail',
  data() {
    return {
      tableData: []
    }
  },
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    onPopperShow() {
      getAccountFreeDetail({
        cust_no: this.rowData.cust_no
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.tableData = result.datas
        } else {
          this.tableData = []
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .feeDetail_page {
    table {
      border-collapse:collapse;
      width: 100%;
      color: #373D41;
      font-size: 12px;
      border: 1px solid rgba(218,227,234,1);
    }
    tbody {
      tr {
        height: 30px;
        &:nth-child(even) {
          background:rgba(248,250,251,1);
        }
      }
      th {
        background: rgba(235,240,243,1);
        line-height: 30px;
        height: 30px;
      }
    }
    .td1 {
      padding-left: 10px;
    }
  }
  .mingxiPop  {
    width: 340px!important;
    .ivu-poptip-body {
      padding: 10px;
      table {
        border-collapse:collapse;
        width: 100%;
        color: #373D41;
        font-size: 12px;
        border: 1px solid rgba(218,227,234,1);
      }
      tr {
        height: 30px;
        line-height: 30px;
        th {
          background: #FFDAE3EA;
          text-align: left;
          padding-left: 10px;
        }
        td {
          text-align: left;
          padding-left: 10px;
        }
      }
    }
  }
</style>
